module.exports = {
  title: '菜单管理',
  route: {
    path: 'system-manage',
    children: {
      path: 'menu-list',
    },
  },
};
